import React from 'react';
import styled from 'styled-components';

import { useDiscountedItem } from 'modules/campaigns/hooks/useDiscountedItem';

import { Estimations, EstimationsProps } from '../Estimations';
import ProductCard from '../ProductCard/ProductCard';

export type ItemDiscountPreviewProps = EstimationsProps & {
  banner?: React.ReactNode;
  itemId?: string;
  menuId: string;
};

const StyledRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-block-start: 12px;
`;

export const ItemDiscountPreview = ({ itemId, menuId, banner, ...estimationsProps }: ItemDiscountPreviewProps) => {
  const { discountedItem } = useDiscountedItem({ itemId, menuId });

  return (
    <StyledRoot>
      <ProductCard product={discountedItem} banner={banner} />
      <Estimations {...estimationsProps} />
    </StyledRoot>
  );
};
